
define(
	'UnlockCommerce.jQueryExtras.jQueryExtras'
	, [
		'jQuery.scStickyButton.Extension'
	]
	, function (
		jQueryExtrasView
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				var layout = container.getComponent('Layout')
			}
		};
	});
